import axios from '@/axios';
import {setCookie} from '@/cookies-helper';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  updateUser({dispatch}, user) {
    return axios.put(`/users/${user._id}`, user).then(response => {
      let date = new Date();
      date.setDate(date.getDate() + 30);
      setCookie('token', response.data.token, date);
      axios.defaults.headers.common.authorization = response.data.token
        ? response.data.token
        : '';
    });
  },
  getFullUser({}) {
    return new Promise((resolve, reject) => {
      axios.get(`/users/get-full`).then(response => {
        return resolve(response.data);
      });
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
